import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { PurchasePlusPageInfoFragmentDoc } from './PageInfo.generated'
import * as Types from './purchasePlus_graphql'

export const GetDeptAndAccountDepartmentsDocument = gql`
  query GetDeptAndAccountDepartments(
    $organisationId: Int!
    $after: String
    $before: String
    $filters: OrganisationsQueryFiltersInput
    $first: Int
    $last: Int
    $sorts: [OrganisationsQuerySortsInput!]
  ) {
    organisation(id: $organisationId) {
      id
      selfAndDescendants(after: $after, before: $before, filters: $filters, first: $first, last: $last, sorts: $sorts) {
        edges {
          node {
            id
            name
          }
        }
        pageInfo {
          ...PurchasePlusPageInfo
        }
      }
    }
  }
  ${PurchasePlusPageInfoFragmentDoc}
` as unknown as DocumentNode<Types.GetDeptAndAccountDepartmentsQuery, Types.GetDeptAndAccountDepartmentsQueryVariables>
